import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import Profile from "../types/Profile";
import {ME_BASE_URL} from "../../../config/config";
import {useOidcClientContext} from "../../ui/context/OidcClientContext";
import useCustomerContext from "../../customers/hooks/useCustomerContext";

type Output = Profile;

export default function useProfileGet (
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const {client: oidcClient} = useOidcClientContext();
    const {languageCode} = useCustomerContext();
    const client = useAPIClient(ME_BASE_URL);

    client.onError(error => {
        if (error.statusCode === 401) {
            oidcClient.login({
                locale: languageCode,
            }).then();
        } else {
            throw error;
        }
    });

    return useCacheQuery<Output>(
        ["profile-me"],
        () => {
            return client.get<any>(`profile`);
        },
        options
    );
}
